<div class="grid-container v-pad">
  @if (dataLoading?.value === false) {
    @if (isCredited) {
      <div class="grid-x user-form-max-width">
        @if (authorization && !isError) {
          <div class="cell small-12 medium-12">
            <receipt [applicationNumber]="applicationNumber"
              [records]="fees"
              [authorization]="authorization"
              [autoGeneratePdf]="generatePdf"
              [isPaid]="true"
              [isCredit]="true"
              [disableInvoice]="false"
              [config]="receiptConfig"
              [isSinglePaymentType]="true"
              (receiptIssued)="onReceiptIssued($event)">
            </receipt>
          </div>
        }
        @if (authorizationResponse || isError) {
          <div class="cell small-12 medium-12">
            {{cancellationText}}
          </div>
        }
      </div>
    }
    @if (isLiquidAsset) {
      <div class="grid-x user-form-max-width">
        @if (!(loadingInvoice$ | async)) {
          <div class="cell small-12 medium-12">
            <receipt [applicationNumber]="applicationNumber"
              [records]="fees"
              [autoGeneratePdf]="generatePdf"
              [isPaid]="false"
              [isCredit]="false"
              [disableInvoice]="false"
              [isSinglePaymentType]="fees != null && fees.length == 1"
              [config]="receiptConfig"
              (receiptIssued)="onReceiptIssued($event)">
            </receipt>
          </div>
        } @else {
          Loading invoice ... please wait ...
        }
      </div>
    }
  }
  <text-loader [run]="dataLoading?.value === true" [text]="'Loading'" [interval]="1000" [tickType]="'.'"></text-loader>
</div>
